import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

export default function FeaturedProducts() {
  const hotProducts = products.filter((p) => p.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热门单品推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              精选最受小熊粉丝喜爱的治愈好物
            </p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotProducts.map((product) => (
            <div
              key={product.id}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-200 hover:scale-[1.02]"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  title={`${product.name} - 黄油小熊热门周边`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                  {product.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 mb-1 line-clamp-2">
                  {product.name}
                </h3>
                <p className="text-sm font-semibold text-primary-600">{product.price}</p>
              </div>
            </div>
          ))}
        </div>

        <Link
          to="/category"
          className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm font-medium text-primary-600 cursor-pointer"
        >
          查看全部产品
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}